import React from 'react';
import Signon from 'pages/Signon';
import Login from 'pages/Login';
import LandingPage from 'pages/LandingPage';
import Hoppon from 'pages/Hoppon';
import LandingPageSecret from 'pages/LandingPageSecret';
import LandingPageMunicipality from 'pages/LandingPageMunicipality';
import ScreeningTest from 'pages/ScreeningTest';
import MinuteSpeech from 'pages/MinuteSpeech';
import CustomLogin from 'pages/CustomLogin';
import LandingPageConexus from 'pages/LandingPageConexus';

// import PermissionRoute from 'components/PermissionRoute';
// import PERMISSIONS from 'utils/permissions';

import {BrowserRouter as Router, Route} from 'react-router-dom';
import {EnvironmentBanner} from 'components/EnvironmentBanner';

import {ENVIRONMENT} from 'constants/index';

// import './App.scss';

const App = () => {
	// const auth = useSelector((state) => state.auth);

	return (
		<div className="PageWrapper">
			<EnvironmentBanner environment={ENVIRONMENT} />
			<Router>
				<Route path="/" exact component={LandingPage} />
				<Route
					path="/narvik"
					exact
					component={LandingPageMunicipality}
				/>
				<Route path="/conexus" exact component={LandingPageConexus} />
				<Route path="/hoppon/" component={Hoppon} />
				<Route path="/login/" component={Login} />
				<Route path="/signon/" component={Signon} />
				<Route path="/custom-login" component={CustomLogin} />
				<Route path="/test/" component={ScreeningTest} />
				<Route path="/oneminutespeech/" component={MinuteSpeech} />

				{/* <Route
					path="/JJiisTezRREXXDSSERllliOR321Frrsaas/"
					component={LandingPageSecret}
				/> */}
			</Router>
		</div>
	);
};

export default App;
